class WishlistDrawer extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.setupWishlist = this.setupWishlist.bind(this)

    this.populateProducts = this.populateProducts.bind(this)

    this.wishlistError = this.wishlistError.bind(this)

    window.SwymCallbacks = window.SwymCallbacks || []
    window.SwymCallbacks.push((swat) => {
      window._swat.fetchLists({
        callbackFn: this.populateProducts,
        errorFn: this.wishlistError,
      })
    })
  }

  populateProducts (lists) {
    if (lists.length === 0) {
      this.els.products.element.setAttribute('aria-hidden', true)
      this.els.empty.element.setAttribute('aria-hidden', false)

      return
    }

    const listId = lists[0].lid

    this.els['list-name'].element.textContent =
      `${lists[0].lname} (${lists[0].cnt})`

    const listConfig = {
      lid: listId,
    }

    window._swat.fetchListDetails(
      listConfig,
      this.setupWishlist,
      this.wishlistError,
    )
  }

  async setupWishlist (wishlist) {
    const productCardHTML = await this.getAllProductCardHTML(wishlist)
    this.els.products.element.innerHTML = productCardHTML

    if (wishlist.list.cnt > 0) {
      this.els.products.element.setAttribute('aria-hidden', false)
      this.els.empty.element.setAttribute('aria-hidden', true)
    } else {
      this.els.products.element.setAttribute('aria-hidden', true)
      this.els.empty.element.setAttribute('aria-hidden', false)
    }
  }

  async getAllProductCardHTML (wishlist) {
    const productCardHTML = await Promise.all(
      wishlist.items.map(
        async (product, index) => await this.getProductCardHTML(product, index),
      ),
    )
    return productCardHTML.filter(Boolean).join('')
  }

  async getProductCardHTML (product, index) {
    const productUrl = product.du.replace(
      '/products/',
      `${window.Shopify.routes.root}products/`,
    )

    return window.BAO.sectionRenderer
      .fetchSingle(
        'wishlist-drawer-product-card',
        `${productUrl}?variant=${product.epi}`,
      )
      .then((res) => {
        const newDOM = window.BAO.sectionRenderer.convertToDOM(res)
        const myself = newDOM.querySelector('article')

        if (myself) {
          return `<div class="drw-Wishlist_Item">${myself.outerHTML}</div>`
        }
      })
      .catch(() => {
        return null
      })
  }

  wishlistError (errorMessage) {
    // eslint-disable-next-line
    console.log(`Wishlist error: ${errorMessage}`);

    this.els.empty.element.setAttribute('aria-hidden', false)
    this.els.products.element.setAttribute('aria-hidden', true)
  }
}

if (!customElements.get('wishlist-drawer')) {
  customElements.define('wishlist-drawer', WishlistDrawer)
}
